import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-y-auto",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_3 = { class: "inline-block align-bottom rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full bg-white dark:bg-gray-800 text-gray-900 dark:text-white" }
const _hoisted_4 = { class: "px-4 pt-5 pb-4 sm:p-6 sm:pb-4 bg-white dark:bg-gray-800" }
const _hoisted_5 = { class: "sm:flex sm:items-start" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "text-lg leading-6 font-medium mb-4 text-gray-900 dark:text-gray-100" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300" }
const _hoisted_10 = {
  key: 0,
  class: "text-xs text-blue-600 dark:text-blue-400 ml-1 font-normal"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = { class: "relative" }
const _hoisted_18 = { class: "px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse bg-gray-50 dark:bg-gray-700" }
const _hoisted_19 = ["disabled"]

import { ref, reactive, watch } from 'vue'
import { packagesApiClient } from '../../../services/api/packagesApiClient'
import type { WorkerFilter } from '../../../types/workers-filter'


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateFilterModal',
  props: {
    modelValue: { type: Boolean },
    editMode: { type: Boolean },
    filterData: {},
    subscription: {}
  },
  emits: ["update:modelValue", "created", "updated"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const isSubmitting = ref(false)

const formData = reactive({
  developerTopic: '',
  addedBy: '',
  matchCondition: '',
  isIntegrations: false,
  subscription: props.subscription || ''
})

// Initialize form data when filterData changes
watch(
  () => props.filterData,
  (newFilter) => {
    if (newFilter && props.editMode) {
      formData.developerTopic = newFilter.developerTopic
      formData.addedBy = newFilter.addedBy || ''
      formData.matchCondition =
        typeof newFilter.matchCondition === 'string'
          ? newFilter.matchCondition
          : JSON.stringify(newFilter.matchCondition, null, 2)
      formData.isIntegrations = newFilter.isIntegrations || false
      formData.subscription = newFilter.subscription || ''
    } else {
      formData.developerTopic = ''
      formData.addedBy = ''
      formData.matchCondition = ''
      formData.isIntegrations = false
      formData.subscription = props.subscription || ''
    }
  },
  { immediate: true }
)

// Auto-populate developer topic when subscription ends with "-sub" AND isIntegrations is checked
const updateDeveloperTopic = () => {
  if (formData.subscription && formData.subscription.endsWith('-sub') && formData.isIntegrations) {
    const baseName = formData.subscription.slice(0, -4) // Remove "-sub"
    formData.developerTopic = `${baseName}-itr-tpc`
  } else if (!formData.isIntegrations) {
    // Clear auto-populated value when checkbox is unchecked to allow manual entry
    if (formData.developerTopic.endsWith('-itr-tpc')) {
      formData.developerTopic = ''
    }
  }
}

// Watch both subscription and isIntegrations checkbox
watch(() => formData.subscription, updateDeveloperTopic)
watch(() => formData.isIntegrations, updateDeveloperTopic)

const handleSubmit = async () => {
  try {
    isSubmitting.value = true

    // Validate JSON
    let matchCondition: any
    try {
      matchCondition = JSON.parse(formData.matchCondition)
    } catch (e) {
      alert('Invalid JSON in match condition')
      return
    }

    if (props.editMode && props.filterData) {
      // Emit update event with updated filter data
      emit('updated', {
        ...props.filterData,
        developerTopic: formData.developerTopic,
        addedBy: formData.addedBy,
        matchCondition,
        isIntegrations: formData.isIntegrations,
        subscription: formData.subscription
      })
    } else {
      // Create new filter
      await packagesApiClient.post('/platform/workers/version-configs', {
        subscription: formData.subscription,
        developerTopic: formData.developerTopic,
        addedBy: formData.addedBy,
        matchCondition,
        isIntegrations: formData.isIntegrations
      })
      emit('created')
    }

    emit('update:modelValue', false)
  } catch (error) {
    // Failed to process filter - use alert for user feedback instead of console.error
    alert('Failed to process filter. Please check your input and try again.')
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_ctx.modelValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity",
            "aria-hidden": "true",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("form", {
              onSubmit: _withModifiers(handleSubmit, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.editMode ? 'Edit Worker Filter' : 'Create Worker Filter'), 1),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("label", _hoisted_9, [
                        _cache[7] || (_cache[7] = _createTextVNode("Developer Topic * ")),
                        (formData.isIntegrations)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, " (Auto-populated) "))
                          : _createCommentVNode("", true),
                        _cache[8] || (_cache[8] = _createStaticVNode("<span class=\"relative inline-block ml-1 group\"><svg class=\"w-4 h-4 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 cursor-help inline-block\" fill=\"currentColor\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z\" clip-rule=\"evenodd\"></path></svg><div class=\"absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap z-10 pointer-events-none\"> Ensure this topic exists <div class=\"absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900\"></div></div></span>", 1))
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.developerTopic) = $event)),
                        type: "text",
                        disabled: formData.isIntegrations,
                        class: _normalizeClass([
                      'w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-1',
                      formData.isIntegrations
                        ? 'bg-gray-100 dark:bg-gray-600 text-gray-500 dark:text-gray-400 cursor-not-allowed border-gray-200 dark:border-gray-500'
                        : 'bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-blue-500 dark:focus:border-blue-400'
                    ]),
                        placeholder: "e.g., my-developer-topic",
                        required: ""
                      }, null, 10, _hoisted_11), [
                        [_vModelText, formData.developerTopic]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300" }, "Added By *", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.addedBy) = $event)),
                        type: "text",
                        class: "w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-1 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-blue-500 dark:focus:border-blue-400",
                        placeholder: "e.g., John Doe",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formData.addedBy]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300" }, "Subscription", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.subscription) = $event)),
                        type: "text",
                        class: "w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-1 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-blue-500 dark:focus:border-blue-400",
                        placeholder: "e.g., my-subscription"
                      }, null, 512), [
                        [_vModelText, formData.subscription]
                      ]),
                      _cache[11] || (_cache[11] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500 dark:text-gray-400" }, " Optional subscription identifier for this filter ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          id: "isIntegrations",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.isIntegrations) = $event)),
                          type: "checkbox",
                          class: "h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700"
                        }, null, 512), [
                          [_vModelCheckbox, formData.isIntegrations]
                        ]),
                        _cache[12] || (_cache[12] = _createElementVNode("label", {
                          for: "isIntegrations",
                          class: "ml-2 block text-sm text-gray-700 dark:text-gray-300"
                        }, " IsInterop Filter ", -1))
                      ]),
                      _cache[13] || (_cache[13] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500 dark:text-gray-400" }, " Check this if this filter is specifically for interop ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300" }, "Match Condition *", -1)),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.matchCondition) = $event)),
                          class: "w-full h-48 px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-1 font-mono text-sm bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-blue-500 dark:focus:border-blue-400",
                          placeholder: "{ \"key\": \"value\" }",
                          required: ""
                        }, null, 512), [
                          [_vModelText, formData.matchCondition]
                        ])
                      ]),
                      _cache[15] || (_cache[15] = _createElementVNode("p", { class: "mt-1 text-sm text-gray-500 dark:text-gray-400" }, " Enter a JSON object that defines the match condition for filtering events. ", -1))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2.5 bg-blue-500 text-base font-medium text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400 sm:w-auto sm:text-sm",
                  disabled: isSubmitting.value
                }, _toDisplayString(_ctx.editMode ? 'Update' : 'Create') + " Filter ", 9, _hoisted_19),
                _createElementVNode("button", {
                  type: "button",
                  class: "mt-3 w-full inline-flex justify-center rounded-md border shadow-sm px-4 py-2.5 text-base font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:mr-3 sm:w-auto sm:text-sm bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
                }, " Cancel ")
              ])
            ], 32)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})